import React, { useCallback } from 'react'
import { DropdownItem } from 'util/ui'
import { file as FileIcon } from 'assets/icons/groove/v2'
import { sendTranscript } from 'ducks/chat/utils/rooms'

const MessengerLinkItem = ({ matrixRoomId }) => {
  const handleClick = useCallback(
    e => {
      e.preventDefault()
      sendTranscript(matrixRoomId)
    },
    [matrixRoomId]
  )

  return (
    <DropdownItem className="link-item" aria-checked="false">
      <a href="#transcript" onClick={handleClick} className="col">
        <div className="name">Send transcript as attachment</div>
        <div className="icon">
          <FileIcon />
        </div>
      </a>
    </DropdownItem>
  )
}

export default MessengerLinkItem
